import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ReportTimeIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ReportTimeIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ReportTimeIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ReportTimeIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ReportTimeIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M15 9a7 7 0 110 14 7 7 0 010-14zm-3-9c1.235 0 2.29.758 2.752 1.828L14.82 2H19c1.05 0 1.918.82 1.994 1.851L21 4v5.292a9.017 9.017 0 00-1.999-1.356L19 4h-2v3H7V4H5v16l1.936.001c.362.728.82 1.4 1.356 2L5 22c-1.05 0-1.918-.82-1.994-1.851L3 20V4c0-1.05.82-1.918 1.851-1.994L5 2h4.18C9.6.84 10.7 0 12 0zm3 11a5 5 0 100 10 5 5 0 000-10zm1 2v1.999L19 15v2h-5v-4h2zM12 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ReportTimeIcon.displayName = "ReportTimeIcon";
export default ReportTimeIcon;
